import React, { useEffect, useState } from "react";
import { useNavigate, Link, useLocation } from "react-router-dom";
import Header from "../Components/Header";
import BreadcrumbMain from "../Components/BreadcrumbMain";
import heroImg from '../Images/blogs-hero.webp';
import { blogsData } from "../Blog";
import ctaBg from '../Images/blog-cta.webp';
import { FaSearch } from "react-icons/fa";
import SchemaMarkup from "../Components/SchemaMarkup";
import breadcrumbSchema from '../Schemas/breadcrumbSchema'

const Blogs=()=>{

    useEffect(() => {
            document.title =
              "Property Settlement Blog Perth | LDL Settlement Services";
        
            const metaDesc = document.querySelector("meta[name='description']");
            if (metaDesc) {
              metaDesc.setAttribute(
                "content",
                "Read property settlement tips, buyer & seller guides, conveyancing insights, and WA property updates from LDL Settlement Services."
              );
            }
        
            const canonical = document.querySelector("link[rel='canonical']");
          if (canonical) {
            canonical.setAttribute("href", "https://ldlsettlementservices.com.au/blog");
          }
        
          const ogTitle = document.querySelector("meta[property='og:title']");
          if (ogTitle) {
            ogTitle.setAttribute(
              "content",
              "Property Settlement Blog Perth | LDL Settlement Services"
            );
          }
        
            const ogDesc = document.querySelector("meta[property='og:description']");
          if (ogDesc) {
            ogDesc.setAttribute(
              "content",
              "Read property settlement tips, buyer & seller guides, conveyancing insights, and WA property updates from LDL Settlement Services."
            );
          }
        
          const ogUrl = document.querySelector("meta[property='og:url']");
          if (ogUrl) {
            ogUrl.setAttribute("content", "https://ldlsettlementservices.com.au/blog");
          }
        
            const ogImage = document.querySelector("meta[property='og:image']");
          if (ogImage) {
            ogImage.setAttribute(
              "content",
              "https://ldlsettlementservices.com.au/Images/blog-img.webp"
            );
          }
        
            const twitterTitle = document.querySelector("meta[name='twitter:title']");
          if (twitterTitle) {
            twitterTitle.setAttribute(
              "content",
              "Property Settlement Blog Perth | LDL Settlement Services"
            );
          }
        
            const twitterDesc = document.querySelector(
            "meta[name='twitter:description']"
          );
          if (twitterDesc) {
            twitterDesc.setAttribute(
              "content",
              "Read property settlement tips, buyer & seller guides, conveyancing insights, and WA property updates from LDL Settlement Services."
            );
          }
        
            const twitterImage = document.querySelector("meta[name='twitter:image']");
          if (twitterImage) {
            twitterImage.setAttribute(
              "content",
              "https://ldlsettlementservices.com.au/Images/blog-img.webp"
            );
          }
          }, []);

const navigate = useNavigate();
  const location = useLocation();
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedCategory, setSelectedCategory] = useState("All");
  const [appliedSearch, setAppliedSearch] = useState("");

const BLOGS_PER_PAGE = 6;

const handlePageChange = (newPage) => {
  setCurrentPage(newPage);

  navigate(`/blog?page=${newPage}`, {
    replace: true,
  });

  setTimeout(() => {
    const element = document.getElementById("blog-grid");

    if (element) {
      element.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }
  }, 50);
};

const getPageFromUrl = () => {
  const params = new URLSearchParams(window.location.search);
  const page = parseInt(params.get("page"), 10);

  return page && page > 0 ? page : 1;
};

const [currentPage, setCurrentPage] = useState(getPageFromUrl);


  const safeBlogsData = Array.isArray(blogsData) ? blogsData : [];

  // Catch redirected navigation parameters inside Blogs.jsx
  useEffect(() => {
    if (location.state) {
      if (location.state.selectCategory) {
        setSelectedCategory(location.state.selectCategory);
        setSearchTerm("");
        setAppliedSearch("");
      } else if (location.state.searchString) {
        setAppliedSearch(location.state.searchString);
        setSearchTerm(location.state.searchString);
        setSelectedCategory("All");
      }
      
      // Smoothly push view into focus right after updating state
      setTimeout(() => {
        const element = document.getElementById("blog-grid");
        if (element) {
          element.scrollIntoView();
        }
      }, 100);

      window.history.replaceState({}, document.title);
    }
  }, [location.state]);
  // Extract unique categories safely
  const categoriesList = ["All"];
  safeBlogsData.forEach((blog) => {
    if (blog && blog.category && !categoriesList.includes(blog.category)) {
      categoriesList.push(blog.category);
    }
  });

  // Handle category changes explicitly
  const handleCategoryClick = (categoryName) => {
    setSelectedCategory(categoryName);
    setSearchTerm("");
    setAppliedSearch(""); // Clear the active filters completely on category tap
  };

  // Generate live dropdown suggestions based on active typing (searchTerm)
  const suggestions = [];
  const cleanTerm = searchTerm.trim().toLowerCase();
  if (cleanTerm !== "") {
    categoriesList.forEach((cat) => {
      if (cat !== "All" && cat.toLowerCase().includes(cleanTerm)) {
        suggestions.push({ type: "category", value: cat });
      }
    });

    safeBlogsData.forEach((blog) => {
      if (blog && blog.title && blog.title.toLowerCase().includes(cleanTerm)) {
        suggestions.push({ type: "blog", value: blog.title, slug: blog.slug });
      }
    });
  }

  // Handle keypress action rule (When user hits Enter)
  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      // If there are autocomplete dropdown items present
      if (suggestions.length > 0) {
        const topResult = suggestions[0]; // Get the item at the very top
        
        if (topResult.type === "category") {
          setSelectedCategory(topResult.value);
          setSearchTerm("");
          setAppliedSearch(""); 
        } else if (topResult.type === "blog") {
          navigate(`/blog/${topResult.slug}`);
        }
      } else {
        // No items are in the dropdown list, run search against whatever text is typed
        setAppliedSearch(searchTerm);
      }
    }
  };

  // Live filter grid matching against appliedSearch rather than live typing inputs
  const filteredBlogs = safeBlogsData.filter((blog) => {
    if (!blog) return false;

    // 1. Category evaluation
    const matchesCategory = 
      selectedCategory === "All" || 
      blog.category === selectedCategory;

    // 2. Applied text evaluation
    const cleanAppliedSearch = appliedSearch.trim().toLowerCase();
    const matchesSearch =
      cleanAppliedSearch === "" ||
      (blog.title && blog.title.toLowerCase().includes(cleanAppliedSearch)) ||
      (blog.category && blog.category.toLowerCase().includes(cleanAppliedSearch));

    return matchesCategory && matchesSearch;
  });

 const totalPages = Math.ceil(
  filteredBlogs.length / BLOGS_PER_PAGE
);

// Make sure current page is never greater than total pages
const safeCurrentPage =
  totalPages > 0
    ? Math.min(currentPage, totalPages)
    : 1;

const startIndex =
  (safeCurrentPage - 1) * BLOGS_PER_PAGE;

const paginatedBlogs = filteredBlogs.slice(
  startIndex,
  startIndex + BLOGS_PER_PAGE
);

useEffect(() => {
    if (location.state) {
     if (location.state.selectCategory) {

  setSelectedCategory(location.state.selectCategory);
  setSearchTerm("");
  setAppliedSearch("");
  setCurrentPage(1);

} else if (location.state.searchString) {

  setAppliedSearch(location.state.searchString);
  setSearchTerm(location.state.searchString);
  setSelectedCategory("All");
  setCurrentPage(1);

}
      
      // Smoothly push view into focus right after updating state
      setTimeout(() => {
        const element = document.getElementById("blog-grid");
        if (element) {
          element.scrollIntoView();
        }
      }, 100);

      window.history.replaceState({}, document.title);
    }
  }, [location.state]);

  useEffect(() => {
  const page = getPageFromUrl();

  setCurrentPage(page);
}, [location.search]);

const breadcrumbs = breadcrumbSchema([
  {
    name: "Home",
    url: "https://ldlsettlementservices.com.au/"
  },
  {
    name: "Blog"
  }
]);
    return(
        <>

<SchemaMarkup schema={breadcrumbs} />

         {/**HEADER */}
         <Header
        showBreadcrumb={true}
        pageName="Blog"
      />

      {/**HERO SECTION */}
       <BreadcrumbMain
      subTitle="BLOG"
      title="Insights, Tips & Property Knowledge"
      description="Stay informed with the latest property updates, settlement tips and helpful guides from our experienced team."
      image={heroImg}
      showIcons={false}
    />

    {/**BLOG CARDS SECTION */}
   <section className="blog-page-section container" id="blog-grid">
        
        {/* LEFT COLUMN - CARDS */}
        <div className="blog-page-left">
          {filteredBlogs.length === 0 ? (
            <div className="no-blogs-section">
              <h2 className="section-heading">No Blogs Found</h2>
              <p className="section-text">We couldn't find any entries for your active selection.</p>
              <button 
                onClick={() => handleCategoryClick("All")}
                style={{ marginTop: "15px", padding: "8px 16px", cursor: "pointer" }}
                className="primary-btn"
              >
                Reset Filters
              </button>
            </div>
          ) : (
            paginatedBlogs.map((item, index) => {
              if (!item) return null;
              return (
                <div className="blog-card" key={item.slug || `blog-idx-${index}`}>
                  <div className="blog-img-wrap">
                    <img
                      src={item.image}
                      alt={`${item.title || 'Property Blog'} | LDL Settlement Services`}
                    />
                    <div className="blog-page-date">
                      <span>{item.date}</span>
                      <span className="meta-dot"></span>
                      <p>{item.category}</p>
                    </div>
                  </div>

                  <div className="blog-content">
                    <h3 className="card-heading">{item.title}</h3>
                    <p className="section-text">{item.desc}</p>
                    <div>
                      <Link to={`/blog/${item.slug}`} className="blog-read-btn">
                        Read More <span>❯</span>
                      </Link>
                    </div>
                  </div>
                </div>
              );
            })
          )}
          {totalPages > 1 && (
  <div className="blog-pagination">

    <button
      className="pagination-btn"
      disabled={safeCurrentPage === 1}
      onClick={() =>
        handlePageChange(safeCurrentPage - 1)
      }
    >
      Previous
    </button>

    <span className="pagination-info">
      Page {safeCurrentPage} of {totalPages}
    </span>

    <button
      className="pagination-btn"
      disabled={safeCurrentPage === totalPages}
      onClick={() =>
        handlePageChange(safeCurrentPage + 1)
      }
    >
      Next
    </button>

  </div>
)}
        </div>

        {/* RIGHT COLUMN - SIDEBAR */}
        <div className="blog-page-right">
          <div className="blog-right-categories">
            
            {/* SEARCH ELEMENT */}
            <div className="blog-page-search">
              <input
                type="text"
                placeholder="Search Category / Articles"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                onKeyDown={handleKeyDown} // Listen to the hit enter trigger
              />
              {suggestions.length > 0 && (
                <div className="blog-search-dropdown">
                  {suggestions.map((item, idx) => (
                    <div
                      key={`suggest-${idx}`}
                      className="blog-search-item"
                      onClick={() => {
                        if (item.type === "category") {
                          handleCategoryClick(item.value);
                        } else {
                          navigate(`/blog/${item.slug}`);
                        }
                      }}
                    >
                      <span>{item.type === "category" ? "Category" : "Blog"}</span>
                      {item.value}
                    </div>
                  ))}
                </div>
              )}
              <div>
                <FaSearch className="blog-page-search-icon" />
              </div>
            </div>

            {/* CATEGORY SELECTOR SYSTEM */}
            <div className="blog-page-categories">
              <h3 className="card-heading">Categories</h3>
              <div className="blog-page-category-list">
                {categoriesList.map((cat, idx) => (
                  <div key={`cat-btn-${idx}`}>
                    <button
                      className={`blog-category-btn ${selectedCategory === cat ? "active" : ""}`}
                      onClick={() => handleCategoryClick(cat)}
                    >
                      {cat}
                    </button>
                  </div>
                ))}
              </div>
            </div>

          </div>

          {/* CTA MARKETING CARD */}
          <div
            className="blog-page-cta"
            style={{
              backgroundImage: `linear-gradient(#C8B692B5, #18263C), url(${ctaBg})`,
            }}
          >
            <div className="blog-page-cta-content">
              <h3 className="card-heading">Need Help with Your Settlement?</h3>
              <p className="section-text">
                Our experienced team is here to make the process smooth and stress-free.
              </p>
              <div className="blog-page-cta-btns">
                <Link to="/get-a-quote" className="primary-btn">Get a Quote</Link>
                <Link to="/contact-us" className="secondary-btn">Contact us</Link>
              </div>
            </div>
          </div>

        </div>
      </section>
        </>
    )
}
export default Blogs;